import { isValidElement, useContext } from 'react';
import { UNSAFE_RouteContext } from 'react-router';

export const useCurrentRoutePattern = () => {
  try {
    // oxlint-disable-next-line eslint-plugin-react-hooks/rules-of-hooks
    let lastRouteContext = useContext(UNSAFE_RouteContext);
    while (lastRouteContext.outlet) {
      if (
        !isValidElement<{ routeContext: typeof lastRouteContext }>(
          lastRouteContext.outlet
        )
      ) {
        break;
      }
      lastRouteContext = lastRouteContext.outlet.props.routeContext;
    }
    return `/${lastRouteContext.matches
      .map(({ route: { path } }) => path)
      .filter(Boolean)
      .join('/')
      .replaceAll(/\/\*?\//g, '/')}`;
  } catch {
    return null;
  }
};
